module.exports = __webpack_public_path__ + "assets/7c7e09ab2a5eb10ce90258d1c64c1229.png";